<template>
  <div id="top-header">
    <div class="header-logo" v-on:click="Ment">
      <img src="./img/logo-white.png" style="width:150px;height:40px;" />
    </div>
    <div class="center-title" v-on:click="Ment">{{PageTitle}}</div>
    <div class="me" v-show="show1==true">
      <TopMenu :ActiveMenuIndex="ActiveMenuIndex" />
    </div>
  </div>
</template>

<script>
import TopMenu from '../TopMenu/index';
export default {
  name: 'TopHeader',
  components: {
    TopMenu
  },
  props: ['PageTitle','ActiveMenuIndex'],
  data() {
    return {
      show1: false
    };
  },
  methods: {
    Ment() {
      if (this.show1 === false) {
        this.show1 = true;
      } else {
        this.show1 = false;
      }
    },
    MentClose() {
      if (this.show1 === true) {
        this.show1 = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
#top-header {
  position: relative;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  background-color: #1B2445;

  .header-logo {
    margin-left: 20px;
    margin-top: 15px;
  }

  .header-menu-icon {
    margin-left: 10px;
    top: 25px;
    font-size: 26px;
    position: absolute;
    cursor: pointer;
    z-index: 999;
  }

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration,
  .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 500px;
    top: 15px;
    transform: translateX(-50%);
    color: #dadada;
    width: 600px;
  }
  .me {
    z-index: 999;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    /* height: 1090px; */
    flex-shrink: 0;
    float: left;
  }
}
</style>
